import React from "react";

export default function Footer() {
    return (
        <footer className="mt-16 border-t">
            <div className="max-w-6xl mx-auto px-4 py-12 grid gap-10 md:grid-cols-3">
                {/* Column 1: Useful Links */}
                <div>
                    <h3 className="text-lg font-semibold mb-3">Useful links</h3>
                    <ul className="space-y-2 text-sm">
                        <li><a className="hover:underline" href="#/contact">Request A Quote</a></li>
                        <li><a className="hover:underline" href="#/about">How Leasing Works</a></li>
                        <li><a className="hover:underline" href="#/about">Leasing FAQ’s</a></li>
                        <li><a className="hover:underline" href="#/about">Order Process</a></li>
                    </ul>
                </div>

                {/* Column 2: Legal & Compliance */}
                <div>
                    <h3 className="text-lg font-semibold mb-3">Legal & Compliance</h3>
                    <ul className="space-y-2 text-sm">
                        <li><a className="hover:underline" href="#/complaints">Complaints Procedure</a></li>
                        <li><a className="hover:underline" href="#/privacy">Privacy & Cookies Policy</a></li>
                        <li><a className="hover:underline" href="#/terms">Terms & Conditions</a></li>
                        <li><a className="hover:underline" href="#/treating-customers-fairly">Treating Customers Fairly</a></li>
                        <li><a className="hover:underline" href="#/customer-duty-compliance">Consumer Duty Compliance</a></li>
                    </ul>
                </div>

                {/* Column 3: Small Print */}
                <div className="text-xs leading-relaxed text-slate-600">
                    <p>© 2022 Clayton Car Contracts Ltd. All rights reserved. We are a broker, not a lender. Vehicles shown are for illustration only. All offers subject to change, finance approval, and availability.</p>
                    <p className="mt-3">Authorised and regulated by the Financial Conduct Authority (FRN700002). ICO registration: ZA086094. Registered in England & Wales (03324101). Registered address: Brook Farm Barn, Marston, Staffordshire, ST18 9SX.</p>
                </div>
            </div>
        </footer>
    );
}
